import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

export const useInvalidateFindings = () => {
  const queryClient = useQueryClient();

  const invalidateFindings = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: ["DeploymentFindings"],
    });
    queryClient.invalidateQueries({
      queryKey: ["FindingGroups"],
    });
    queryClient.invalidateQueries({
      queryKey: ["TotalFindingCounts"],
    });
    queryClient.invalidateQueries({
      queryKey: ["FindingCounts"],
    });
    queryClient.invalidateQueries({
      queryKey: ["SearchFindings"],
    });
    queryClient.invalidateQueries({
      queryKey: ["finding"],
    });
  }, [queryClient]);

  const invalidateSecrets = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: ["SecretsList"],
    });
    queryClient.invalidateQueries({
      queryKey: ["SecretsCount"],
    });
  }, [queryClient]);

  return { invalidateFindings, invalidateSecrets };
};
